import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { CommentsIcon } from "frontend/app-header/right-header/icons";
import styles from "./right-header.module.css";
import { memo, useEffect, useRef } from "react";
import { useAtom } from "jotai";
import { useHeaderContext } from "frontend/context/header-context";
import { CursorType } from "frontend/canvas-designer-new/cursor-type";
import { SidepanelType, sidePanelType } from "state-atoms";
import { usePrevious } from "react-use";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export const CommentsTrigger = memo(() => {
  const [openedSidePanel, setOpenedSidePanel] = useAtom(sidePanelType);
  const previousCursorType = usePrevious(openedSidePanel);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);
  const { setCursorType } = useHeaderContext();

  useEffect(() => {
    if (openedSidePanel !== SidepanelType.comments && previousCursorType === SidepanelType.comments) {
      setTimeout(() => {
        setCursorType(CursorType.pointer);
      }, 1000);
    }
  }, [openedSidePanel]);

  return (
    <HeaderActionButton
      className={styles.actionIcon}
      onClick={(e) => {
        setCursorType(CursorType.comment);
        setOpenedSidePanel(SidepanelType.comments);
        e.stopPropagation();
        e.preventDefault();
      }}
      ref={iconRef}
    >
      <CommentsIcon />
      {iconHover && (
        <Tooltip
          design="monday"
          label={"Comments"}
          relativeTo={iconRef}
          side={"bottom"}
          customStyle={{ borderRadius: 3 }}
        />
      )}
    </HeaderActionButton>
  );
});

CommentsTrigger.displayName = "CommentsTrigger";
